import * as types from './mutation_types'

export default {
  [types.RESET_STATE] (state) {
    // TODO: в гоалс могут быть вложенные объекты!!
    Object.assign(state, {
      goals: [],
      isLoading: false,
    })
  },

  [types.SET_GOALS] (state, data) {
    state.goals = data
  },

  [types.IS_LOADING] (state) {
    state.isLoading = !state.isLoading
  },

  [types.SET_GOALS_HASH] (state, hash) {
    state.goalsHash = hash
  },
}
